import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Config } from "../../../config/api.config";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Supplier, SupplierRequest } from "../supplier.model";

@Injectable({
  providedIn: "root",
})
export class SuppliersService {
  constructor(private http: HttpClient) {}

  findAllByContractType(contractType: string): Observable<any[]> {
    const params = new HttpParams().set("contractType", contractType);
    return this.http.get<any[]>(`${Config.webApiUrl}/v1/person/contract-type`, { params });
  }

  create(supplier: SupplierRequest, file: File | null): Observable<any> {
    const formData = new FormData();
    formData.append("data", JSON.stringify(supplier));

    if (file) {
      formData.append("file", file);
    }
    return this.http.post<any>(`${Config.webApiUrl}/v1/person`, formData);
  }

  update(id: string, supplier: SupplierRequest, file?: File): Observable<any> {
    const formData = new FormData();
    formData.append("data", JSON.stringify(supplier));

    if (file) {
      formData.append("file", file);
    }

    return this.http.put(`${Config.webApiUrl}/v1/person/${id}`, formData);
  }

  delete(id: string): Observable<Supplier> {
    return this.http.delete<Supplier>(`${Config.webApiUrl}/v1/person/${id}`);
  }
}
